import Listagem from "./Listagem";
import { ModalDetalheTituloPagarProvider } from "../ModalDetalheTituloContext";

export default function ListarTodas() {
    return (
        <>
            <ModalDetalheTituloPagarProvider>
                <Listagem />
            </ModalDetalheTituloPagarProvider>
        </>
    )
}